import React, { useState } from 'react';
import './Navbars.css';
import { Link } from 'react-router-dom';
import IIICFile from './IQAC DOCUMENT/IIIC cell of IQAC.pdf';
import committee from './IQAC DOCUMENT/Committee of IQAC.pdf';
import Sc from './IQAC DOCUMENT/Sc cell IQAC.pdf';
import Alumni from './IQAC DOCUMENT/Alumni-meet.pdf';
import FDP from './IQAC DOCUMENT/FDP.pdf';
import Notice from './IQAC DOCUMENT/ALUMNI (1).pdf';
import placement from './IQAC DOCUMENT/B.TECH PLACEMENT 2020 ONWARDS.pdf';

const Navbars = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar bar1 ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar bar2 ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar bar3 ${isMenuOpen ? 'open' : ''}`}></div>
      </div>

      <ul className={`navbar-links ${isMenuOpen ? 'show' : ''}`}>
        <li><Link to="/">HOME</Link></li>

        {/* ABOUT US */}
        <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdown(0)}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="#" className="dropdown-link">ABOUT US</a>
          {activeDropdown === 0 && (
            <ul className="dropdown-menu">
              <li><Link to="/OverView">OverView</Link></li>
              <li><Link to="/InfraStructure">InfraStructure</Link></li>
              <li><Link to="/Message">Message's</Link></li>
              <li><Link to="/Affiliation">Affiliation</Link></li>
              <li><Link to="/Vision_Mission">Vision Mission</Link></li>
            </ul>
          )}
        </li>

        {/* ACADEMICS */}
        <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdown(2)}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="#" className="dropdown-link">ACADEMICS</a>
          {activeDropdown === 2 && (
            <ul className="dropdown-menu">
              <li><Link to="#">Curriculum</Link></li>
              <li><Link to="#">Faculty</Link></li>
              <li><Link to="/admission">Admission</Link></li>
              <li><Link to="/Syllabus">Syllabus Downlod</Link></li>
            </ul>
          )}
        </li>

        {/* DEPARTMENT */}
        <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdown(3)}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="#" className="dropdown-link">DEPARTMENT</a>
          {activeDropdown === 3 && (
            <ul className="dropdown-menu">
              <li><Link to="/Civil">Civil Engineering</Link></li>
              <li><Link to="/Computerlab">Applied Science</Link></li>
              <li><Link to="/Electrical">Electrical Engineering</Link></li>
              <li><Link to="/Mechanical">Mechanical Engineering</Link></li>
              <li><Link to="/Computer">Computer Science Engineering</Link></li>
              <li><Link to="/Electronic">Electronics and Communication Engineering</Link></li>
            </ul>
          )}
        </li>

        {/* IQAC (NAAC) */}
        <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdown(4)}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="#" className="dropdown-link">IQAC(NAAC)</a>
          {activeDropdown === 4 && (
            <ul className="dropdown-menu">
              <li><Link to="/Iqac">About IQAC</Link></li>
              <li><Link to="/Naac">Executive Summary</Link></li>
              <li className="dropsection">
                <p style={{fontSize:"16px",marginLeft:"10px"}}>Profile of the <br /> College</p> 
                <ul className="dropsection1">
                <li><a href="/Notice/profile merge.pdf" download>2</a></li>

                  <li><Link to="/Naac_2">Naac_2A</Link></li>
                  <li><Link to="/Naac_2b">Naac_2B</Link></li>
                </ul>
              </li>
              <li><a href={IIICFile} download>IIIC Cell of IQAC</a></li>
              <li><a href={committee} download>Committee of IQAC</a></li>
              <li><a href={Sc} download>Sc Cell of IQAC</a></li>
              <li><a href={Alumni} download>Alumni Meet</a></li>
              <li><a href={FDP} download>FDP</a></li>
              <li><a href={Notice} download>Alumni Meet Student</a></li>
              <li><Link to="/Report">Activity Report/Form</Link></li>
              <li><Link to="/Notice">Notice</Link></li>
            </ul>
          )}
        </li>

        {/* PLACEMENT */}
        <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdown(5)}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="#" className="dropdown-link">PLACEMENT</a>
          {activeDropdown === 5 && (
            <ul className="dropdown-menu">
              <li><Link to="/Placement">Placement Details</Link></li>
              <li><Link to="/placementlist">Placement</Link></li>
              <li><a href={placement} download>Placement PDF</a></li>
            </ul>
          )}
        </li>

        <li><Link to="/Course">COURSE</Link></li>
        <li><Link to="/NEWS">NEWS</Link></li>
        <li><Link to="/Notices">NOTICE</Link></li>
        <li><Link to="/Gallery">GALLERY</Link></li>
      </ul>
    </nav>
  );
};

export default Navbars;
